import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HIDE_REMOVE_TRACK_DIALOG } from "file-details/fileDetailsActions";
import {
  getRemoveTrackDialogTrack,
  getRemoveTrackDialogVisible,
  getSubmissionFiles,
  getWorkFiles,
} from "common/selectors";
import ConfirmationDialog from "general-components/ConfirmationDialog";
import { useTranslation } from "react-i18next";
import { pipe, propEq, reject } from "ramda";
import { changeSubmissionFiles } from "../../submission/submissionActions";
import { changeWorkFiles } from "../../upload/uploadActions";

const RemoveTrackDialog = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const setSubmissionFiles = pipe(changeSubmissionFiles, dispatch);
  const setWorkFiles = pipe(changeWorkFiles, dispatch);

  const track = useSelector(getRemoveTrackDialogTrack);
  const visible = useSelector(getRemoveTrackDialogVisible);

  const tracks = useSelector(getSubmissionFiles);
  const workFiles = useSelector(getWorkFiles);

  const onCancel = () => dispatch({ type: HIDE_REMOVE_TRACK_DIALOG });

  const onConfirm = () => {
    const updatedFiles = reject(propEq("fileId", track.fileId), tracks);
    const updatedWorkFiles = reject(
      propEq("name", track.originalFilename),
      workFiles
    );
    setSubmissionFiles(updatedFiles);
    setWorkFiles(updatedWorkFiles);

    dispatch({ type: HIDE_REMOVE_TRACK_DIALOG });
  };

  return (
    <ConfirmationDialog
      title={t("file_details_remove_track_title")}
      message={t("file_details_remove_track_message", {
        name: track.originalFilename,
      })}
      confirmButtonText={t("confirmation_yes")}
      onCancel={onCancel}
      onConfirm={onConfirm}
      visible={visible}
    />
  );
};

export default RemoveTrackDialog;
